export const devMode = false; ///Note: mode must be change along with index.html (account)
export const mapSdk = 2;
export const map4DKeyApi = '847bd3a139a982d07c03ba07e4ca443c'